import React, { Component } from 'react'
import axios from 'axios';
import {
  Modal,
} from 'antd';

import moment from "moment";

import LS_SERVICE from '../../utils/localStorage';
import Asideleft from '../../components/aside/asideleft'
import {
  GET_MYCASENOTE_DATA_PATIENT
} from '../../utils/constant';

export default class MyCaseNote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smartemrdatalist: [],
      bedrockMedicineModel: false,
      bedrockMedicine: [],
    }
  }

  async componentDidMount() {
    axios.defaults.headers.common["Authorization"] = LS_SERVICE.get("token");
    const { match: { params } } = this.props;
    const { hospital_id, patient_id } = params;

    axios.post(GET_MYCASENOTE_DATA_PATIENT, {patient_id: patient_id, hospital_id: hospital_id, type: 'fulldate'}).then(smartEmrDataSuccess => {
      if(smartEmrDataSuccess?.data?.data?.length > 0){
        this.setState({
          smartemrdatalist: smartEmrDataSuccess?.data?.data,
        })
      }
    });
  }

  renderData = (data, level = 1) => {
    if (!this.hasContent(data)) return null;
  
    // String
    if (typeof data === "string") {
      return <>{data}</>;
    }
  
    // Array
    if (Array.isArray(data)) {
      return (
        <ul>
          {data.map((item, index) => {
            // Check if it's a Vital Object: { vital_name_and_unit: "...", vital_analysis: "..." }
            if (item && item.vital_name_and_unit) {
              return (
                <li key={index} style={{ marginBottom: '4px' }}>
                  <strong>{item.vital_name_and_unit.split(' (')[0]}:</strong> {item.vital_analysis}
                </li>
              );
            }
            return this.hasContent(item) ? (
              <li key={index} style={{ marginBottom: '4px' }}>{this.renderData(item)}</li>
            ) : null
          })}
        </ul>
      );
    }
  
    if (typeof data === "object" && data !== null) {
      return Object.entries(data).map(([key, value]) => {
        if (!this.hasContent(value)) return null;
  
        return (
          <div key={key} style={{ marginBottom: "10px" }}>
            {/* Key part */}
            <strong style={{ textTransform: "capitalize" }}>
              {level == 1 ? this.formatHeading(key).toUpperCase() : this.formatHeading(key)}:
            </strong>
  
            {/* Value part (This handles the array of strings) */}
            <div style={{ marginLeft: "10px" }}>
               {this.renderData(value, 2)}
            </div>
          </div>
        );
      });
    }
  
    return null;
  };

  hasContent = (value) => {
    // null or undefined
    if (value == null) return false;
  
    // string
    if (typeof value === "string") {
      return value.trim().length > 0;
    }
  
    // array
    if (Array.isArray(value)) {
      if (value.length === 0) return false;
      return value.some(item => this.hasContent(item));
    }
  
    // object
    if (typeof value === "object") {
      const values = Object.values(value);
      if (values.length === 0) return false; // {} case
      return values.some(v => this.hasContent(v));
    }
  
    return false;
  };

  formatHeading = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  viewThisMedicineData(medicines){
    this.setState({
      bedrockMedicineModel: true,
      bedrockMedicine: medicines
    })
  }

  render() {
    const { smartemrdatalist} = this.state;
    return (
      <>
        <Asideleft />
        <div className="content-wrapper">
          <div className="container-fluid emrfrm ">
            <div className="row">
              <div className="col-12">
                <div className="float-left">
                  <h1 className="page-title mb-0">MyCase Note</h1>
                </div>
              </div>
            </div>
            {
              smartemrdatalist.length > 0 
            ? 
              (
                smartemrdatalist.map(case_note => (
                  <div className="row single_page">
                    <div className="col-12">
                      <div className="accordion soap_accordion py-2" id="accordionExample">
                        <div className="card medicines-card mb-0">
                          <div className="card-header p-0 med-card-head" id="caseNoteAccordion">
                            <button className="btn btn-block text-left collapsed arrow float-right mb-0 custom-card-pink" type="button" data-toggle="collapse" data-target={"#collapse_case_note"+case_note.id} aria-expanded="false" aria-controls={"collapse_case_note"+case_note.id}>
                              <div className='row'>
                                <span className='text-bold col-3'>
                                  Encounter Date: {moment(case_note?.patient_visit_date).format('DD MMM YYYY')}
                                </span>
                                <span className='col-5'>
                                  {case_note?.specialization_name} ({case_note?.doctor_name})
                                </span>
                                <span className='col-3'>
                                  Visit Type: {case_note?.visit_type}
                                </span>
                                <span className='col-1 float-right'>
                                {
                                  case_note?.medicines?.length > 0 && (
                                  <i className="icon_view" onClick={() => this.viewThisMedicineData(case_note.medicines)}></i>
                                )}
                                </span>
                              </div>
                            </button>
                          </div>
                          <div id={"collapse_case_note"+case_note.id} className="collapse" aria-labelledby="caseNoteAccordion" >
                            <div className='row mt-2 mb-2 ml-2 mr-2'>
                              <div className='col-12'>
                                {this.renderData(case_note?.airesponse)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )
            :
              <div className="row single_page mt-4">
                <div className="col-12">
                  <div className="accordion soap_accordion py-2">
                    <div className="card medicines-card mb-0">
                      <div className="card-header p-0 med-card-head">
                        <button className="btn btn-block text-center collapsed float-right mb-0 custom-card-pink" type="button">
                          No results found
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

            <Modal
              destroyOnClose={true}
              title="Medicines Prescribed"
              open={this.state.bedrockMedicineModel}
              footer={false}
              width={'48%'}
              onCancel={(e) => this.setState({ bedrockMedicineModel: false, bedrockMedicine: [] })}
              className='mycasemodal'
            > 
              <div className='row mb-4'>
                <div className="col-12">
                  <ul>
                    {this.state.bedrockMedicine.map((item, index) =>
                      <>
                        <br/>
                        <li key={index}>
                          {item?.drugName}
                          {
                            item?.generics?.length > 0 && (
                              item?.generics.join(', ')
                            )
                          }
                          {
                            item?.reasons?.length > 0 && (
                              <>
                                {item?.reasons.map((sitem, sindex) =>
                                  <>
                                    <br/>
                                    <span className='text-danger'>
                                      {moment(sitem.date).format('YYYY-MM-DD HH:mm')} - {sitem?.status} {sitem?.reason && (<> - ({sitem?.reason})</>) }
                                    </span>
                                  </>
                                )}
                              </>
                            )
                          }
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </>
    )
  }
}
